<template>
  <section class="start full-page-section">
    <div class="share" @click="toggleShare">Share</div>
    <div class="content">
      <h2 v-html="strings.h2"></h2>
      <!-- phase 1 content -->
      <!-- <div class="p-content">
        <p>We believe that equality and diversity within music is not only about gender and ethnicity. It is also about who is behind the music in terms of creation and ownership. Today, the global independent market share of streaming is 19.55 percent. The rest is controlled by three major record labels.</p>
        <p>We want this to change and we want to give independent music creators the most important tag for independent content to acknowledge independent music.</p>
        <p>
          Do you want to be a part of this change?
          <a
            href="#"
            v-scroll-to="'#letter-view'"
          >Read our open letter</a> to the streaming giants and sign the petition.
        </p>
      </div>-->
      <!-- phase 2 content -->
      <div class="p-content">
        <p>We believe that equality and diversity within music is not only about gender and ethnicity. It is also about who is behind the music in terms of creation and ownership. Today, the global independent market share of streaming is 19.55 percent. The rest is controlled by three major record labels.</p>
        <p>We want this to change and we want to give independent music creators the most important tag for independent content to acknowledge independent music.</p>
        <p>
          Want to know more?
          <a href="#" v-scroll-to="'#letter-view'">Read our open letter</a> and
          see
          <a href @click.prevent="togglePop">who has signed</a> the petition.
        </p>
      </div>
      <a class="button" @click.prevent="togglePop">See signatures</a>
      <div class="count">
        <p>{{this.signedCount}} people have signed the petition.</p>
      </div>
    </div>
    <transition name="fade">
      <div class="pop" :class="{ 'show-all': showFull }" v-if="showPop">
        <div class="content center" v-if="!signup">
          <h5 v-html="strings.sign"/>
          <!-- Desktop buttons -->
          <a class="facebook-button" @click.prevent="signin">
            <i class="fa fa-facebook-official" aria-hidden="true"></i> Continue with Facebook
          </a>
          <br>
          <a class="google-button" @click.prevent="signinGoogle">
            <i class="fa fa-google" aria-hidden="true"></i> Continue with Google
          </a>
          <!-- Mobile buttons -->
          <a class="facebook-button-mobile" @click.prevent="signinRedirectFacebook">
            <i class="fa fa-facebook-official" aria-hidden="true"></i> Continue with Facebook
          </a>
          <br>
          <a class="google-button-mobile" @click.prevent="signinRedirectGoogle">
            <i class="fa fa-google" aria-hidden="true"></i> Continue with Google
          </a>
          <p class="smaller error">{{error.length > 0 ? error[0] : ''}}&nbsp;</p>
          <p class="smaller">Continue with Facebook or Google to sign the petition.</p>
          <p class="smaller accept" :class="{ accepted: accept }">
            <i class="fa fa-check" @click="acceptClickHandler" aria-hidden="true"></i>
            I accept the
            <a href="#" @click.prevent="toggleTerms">terms and conditions</a> for the privacy policy.
          </p>
        </div>
        <div class="content center thanks-name" v-if="signup">
          <h5>Thank you, {{ user ? user.displayName : ''}}!</h5>
          <h5>Help us to acknowledge independent music and integrate the most important tag for independent content by sharing this video.</h5>
          <iframe
            src="https://www.youtube.com/embed/Xpu82GM6vNk?modestbranding=1"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <br>
          <a class="button" @click.prevent="togglePop">Close</a>
          <br>
        </div>
        <Hamburger class="white" :open="true" @click.native="togglePop"/>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop show-full pop-share" v-if="showShare">
        <div class="content center">
          <h5>Help us to acknowledge independent music and integrate the most important tag for independent content by sharing this video.</h5>
          <iframe
            src="https://www.youtube.com/embed/Xpu82GM6vNk?modestbranding=1"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <br>
        </div>
        <Hamburger class="white" :open="true" @click.native="toggleShare"/>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop-terms" v-if="showTerms">
        <PopFloat :expandable="terms.text" :terms="true"/>
        <Hamburger class="white" :open="true" @click.native="toggleTerms"/>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop-thank-names" v-if="showNames">
        <NameList @toggle="togglePop"/>
      </div>
    </transition>
  </section>
</template>

<script>
import Hamburger from '@/components/Hamburger.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import fire from '@/api/db.js'
import data from '@/data/strings.json'
import PopFloat from '@/components/PopFloat.vue'
import NameList from '@/components/NameList.vue'
import names from '@/api/onlyNames_1212.json'

export default {
  name: 'Start',
  data () {
    return {
      page: {},
      strings: data.start,
      terms: data.terms,
      showFull: false,
      showTerms: false,
      showPop: false,
      signup: false,
      user: null,
      count: '...',
      accept: false,
      error: [],
      showShare: false,
      signedCount: '...',
      showNames: false
    }
  },
  watch: {
    signsOpen () {
      this.togglePop()
    }
  },
  methods: {
    acceptClickHandler () {
      this.error = []
      this.accept = !this.accept
    },
    signinGoogle () {
      this.error = []
      if (!this.accept) {
        this.error.push('You have to accept our terms and conditions.')
        return
      }
      const provider = new firebase.auth.GoogleAuthProvider()
      fire.auth().signInWithPopup(provider).then((result) => {
        this.signup = true
        this.user = result.user
        if (window.gtag) {
          window.gtag('event', 'sign', {
            'event_category': 'signup',
            'event_label': 'successful signup google'
          })
        }
        this.$nextTick(() => {
          this.updateCount()
        })
      }).catch((error) => {
        this.signup = false
        window.gtag('event', 'sign', {
          'event_category': 'canceled signup google',
          'event_label': 'canceled signup'
        })
        console.log(error)
      })
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'click google',
          'event_label': 'click google button'
        })
      }
    },
    signinRedirectGoogle () {
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'click google',
          'event_label': 'click google button'
        })
      }
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithRedirect(provider)
    },
    signinRedirectFacebook () {
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'click facebook',
          'event_label': 'click facebook button'
        })
      }
      const provider = new firebase.auth.FacebookAuthProvider()
      firebase.auth().signInWithRedirect(provider)
    },
    signin () {
      this.error = []
      if (!this.accept) {
        this.error.push('You have to accept our terms and conditions.')
        return
      }
      const provider = new firebase.auth.FacebookAuthProvider()
      fire.auth().signInWithPopup(provider).then((result) => {
        this.signup = true
        this.user = result.user
        if (window.gtag) {
          window.gtag('event', 'sign', {
            'event_category': 'signup',
            'event_label': 'successful signup'
          })
        }
        this.$nextTick(() => {
          this.updateCount()
        })
      }).catch((error) => {
        this.signup = false
        window.gtag('event', 'sign', {
          'event_category': 'canceled signup',
          'event_label': 'canceled signup'
        })
        console.log(error)
      })
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'click facebook',
          'event_label': 'click facebook button'
        })
      }
    },
    togglePage () {
      this.showFull = !this.showFull
    },
    toggleTerms () {
      this.$scrollTo('#start-view', 100)
      this.showTerms = !this.showTerms
    },
    // togglePop () {
    //   this.$scrollTo('#start-view', 100)
    //   this.showPop = !this.showPop
    //   if (window.gtag) {
    //     console.log('sending to ga??')
    //     window.gtag('event', 'click', {
    //       'event_category': 'open',
    //       'event_label': 'open signup'
    //     })
    //   }
    // },
    togglePop () {
      this.$scrollTo('#start-view', 100)
      this.showNames = !this.showNames
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'open',
          'event_label': 'open thank-names'
        })
      }
    },
    toggleShare () {
      this.$scrollTo('#start-view', 100)
      this.showShare = !this.showShare
    },
    updateCount () {
      console.log('updating count')
      this.signedCount = parseInt(this.signedCount) + 1
    },
    updateCountOld () {
      // const db = firebase.firestore(fire)
      // const settings = { timestampsInSnapshots: true }
      // db.settings(settings)
      // let sfDocRef = db.collection('signups').doc('yL24r72Nlybq9LmFyLHo')
      // db.runTransaction(function (transaction) {
      //   return transaction.get(sfDocRef).then(function (sfDoc) {
      //     if (!sfDoc.exists) {
      //       throw new Error('Document does not exist!')
      //     }
      //     var newCount = sfDoc.data().count + 1
      //     transaction.update(sfDocRef, { count: newCount })
      //     return newCount
      //   })
      // }).then(function () {
      //   console.log('Transaction successfully committed!')
      // }).catch(function (error) {
      //   console.log('Transaction failed: ', error)
      // })
    }
  },
  mounted () {
    let self = this
    //  Get redirect result
    firebase.auth().getRedirectResult().then((result) => {
      if (result.user) {
        this.user = result.user
        this.signup = true
        this.showPop = true
        if (window.gtag) {
          window.gtag('event', 'sign', {
            'event_category': 'signup',
            'event_label': 'successful signup google'
          })
        }
        this.$nextTick(() => {
          this.updateCount()
        })
      }
      //  console.log('user from redirect', this.user)
    }).catch((error) => {
      console.log(error)
    })
    this.signedCount = names.length
    // const db = fire.firestore()
    // const settings = { timestampsInSnapshots: true }
    // db.settings(settings)
    // const signedCountRef = db.collection('signed_count')
    // signedCountRef.get().then((snap) => {
    //   self.signedCount = snap.docs.length
    // })
  },
  props: {
    msg: String,
    signsOpen: Boolean
  },
  components: {
    Hamburger,
    PopFloat,
    NameList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.start {
  .button {
    margin-top: 25px;
  }
  @media only screen and (max-width: 600px) {
    padding-top: 40px;
  }
  .pop {
    pointer-events: auto;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.count p {
  font-size: 0.8em;
}
.hamburger.white {
  position: absolute;
  top: 50px;
  right: 15px;
  span {
    background-color: #fff !important;
  }
  @media only screen and (max-width: 600px) {
    right: 0px;
    top: 30px;
  }
}
.pop-terms {
  position: absolute;
  top: 15px;
  left: 0px;
  width: 100%;
  min-height: calc(100vh - 30px);
  .hamburger.white {
    position: fixed;
    top: 65px;
    right: 30px;
    z-index: 105;
    span {
      background-color: #fff !important;
    }
  }
}
.facebook-button,
.google-button,
.facebook-button-mobile,
.google-button-mobile {
  color: #fff;
  display: inline-block;
  border-radius: 4px;
  background-color: #4267b2;
  font-family: Helvetica, Arial, sans-serif;
  padding: 11px 28px 9px 38px;
  width: 250px;
  position: relative;
  i {
    font-size: 1.4em;
    position: absolute;
    left: 15px;
    top: 8px;
  }
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    transform: translateY(2px);
  }
}
.google-button,
.google-button-mobile {
  background-color: #dd3f32;
  margin-top: 10px;
}
.google-button,
.facebook-button {
  display: inline-block;
  @media only screen and (max-width: 1160px) {
    display: none;
  }
}
.facebook-button-mobile,
.google-button-mobile {
  display: none;
  @media only screen and (max-width: 1160px) {
    display: inline-block;
  }
}
.accept {
  display: inline-block;
  position: relative;
  transition: all 0.2s ease;
  margin-left: 20px;
  &:before {
    content: "";
    width: 13.5px;
    height: 13px;
    border: 1px solid #fff;
    position: absolute;
    border-radius: 4px;
    left: -20px;
    top: 2px;
    cursor: pointer;
  }
  i {
    transition: all 0.2s ease;
    opacity: 0;
    content: "";
    width: 13px;
    height: 13px;
    position: absolute;
    border-radius: 4px;
    left: -19.4px;
    top: 4.5px;
    cursor: pointer;
  }
  &.accepted {
    i {
      opacity: 1;
    }
  }
}
.share {
  position: fixed;
  font-size: 0.85rem;
  right: 90px;
  top: 34px;
  z-index: 9999;
  @media only screen and (max-width: 600px) {
    right: 70px;
    top: 26px;
    font-size: 0.95rem;
  }
  cursor: pointer;
  &:hover {
    color: #2effc3;
  }
}
iframe {
  width: 430px;
  height: 242px;
}
@media only screen and (max-width: 600px) {
  iframe {
    width: 100%;
    height: 200px;
  }
}
.pop-share,
.thanks-name {
  h5 {
    //  font-size: 1.5rem;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 1300px) {
    h5 {
      font-size: 1.2rem;
      line-height: 1.4rem;
    }
  }
}
.thanks-name {
  @media only screen and (max-width: 1900px) {
    h5 {
      font-size: 1.3rem;
      line-height: 1.5rem;
    }
  }
  @media only screen and (max-width: 1300px) {
    h5 {
      font-size: 1.2rem;
      line-height: 1.4rem;
    }
  }
}
.pop-terms .pop-float {
  background-color: rgba(57, 57, 67, 1);
}
</style>
